<template>
  <div
    v-if="assets.length"
    class="row q-gutter-x-xs items-end"
  >
    <span
      v-if="assetCount"
      class="count bold text-blue-grey"
      >+{{ assetCount }}
    </span>

    <SocialMentionCardAttachedMediaAsset
      :duration="firstAsset.duration"
      :play-media-in-lightbox="playMediaInLightbox"
      :thumbnail="firstAsset.thumbnail"
      :type="firstAsset.type"
      :url="firstAsset.url"
      @click="openLightboxSocialPostModal"
    />
  </div>
</template>

<script>
import SocialMentionCardAttachedMediaAsset from "shared/components/SocialMentionCardAttachedMediaAsset.vue";

export default {
  name: "SocialMentionCardAttachedMedia",
  components: {
    SocialMentionCardAttachedMediaAsset,
  },
  props: {
    assets: {
      type: Array,
      required: true,
    },
    mention: {
      type: Object,
      default: null,
    },
    playMediaInLightbox: {
      type: Boolean,
    },
  },
  computed: {
    firstAsset() {
      return this.assets[0];
    },
    assetCount() {
      return this.assets.length - 1;
    },
  },
  methods: {
    openLightboxSocialPostModal() {
      const { mention, assets } = this;

      this.$modals.open("LightboxSocialPostModal", {
        props: {
          mention,
          assets,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.count {
  font-size: 11px;
  line-height: 15px;
}
</style>
